import { useBooleanCookie } from '@/plugins/cookie-plugin'

export function useIsAdmin() {
    return useBooleanCookie('admin_activity')
}
